import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";
import performRequest from "../../../api/request";
import { Toast } from "../../../CustomComponent/toast";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import Footer from "../../../Components/Footer/footer";
import { useSelector } from "react-redux";
import { IoIosArrowDown, IoIosArrowRoundUp } from "react-icons/io";
import DynamicFilterSelect from "../../../../Kryzen Alpha App/Components/layouts/filter.select";
import getFilteredURL from "../../../Components/Functions/filters.getUrl";
import Pagination from "../../../Components/layouts/pagination";

const FarmerEpgDashboard = () => {
  const [data, setData] = useState(null);
  const navigate = useNavigate();
  const { id } = useParams(); // farmer partner id in suparadmin
  const [orders, setOrders] = useState([]);
  const store = useSelector((store) => store.login.user);
  const [farmerPartnerId, setFarmerPartnerId] = useState(null);
  const [analyticsData, setAnalyticsData] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const [filters, setFilters] = useState({
    orderStatus: "",
    sortByDate: "",
  });

  const [showPage, setShowPage] = useState(1);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  useEffect(() => {
    if (
      store?.AdditionalRole === "farmer partner" ||
      store?.Role === "superAdmin"
    ) {
      performRequest(
        "GET",
        `pmg/farmer-partner/farmer-partner-id/${store?.UserId}`
      )
        .then((res) => {
          setFarmerPartnerId(res?.data?.farmerPartnerId);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, []);
  useEffect(() => {
    if (farmerPartnerId || id) {
      getOrders(farmerPartnerId);
    }
  }, [farmerPartnerId, page, refresh]);
  const getOrders = async (farmerPartnerId) => {
    try {
      if (store?.AdditionalRole === "farmer partner") {
        const res = await performRequest(
          "GET",
          getFilteredURL(
            `/pmg/farmer-partner/get-farmer-order-recieved-by-id/${farmerPartnerId}`,
            page,
            filters
          )
        );

        if (res.status === 200) {
          setOrders(res?.data?.getOrdersDetails);
          setTotalPages(Math.ceil(res.data?.orderDetailsCount / 50));
        } else {
          Toast("error", "Failed to fetch details");
        }
      } else {
        const res = await performRequest(
          "GET",
          getFilteredURL(
            `/pmg/farmer-partner/get-farmer-order-recieved-by-id/${id}`,
            page,
            filters
          )
        );

        if (res.status === 200) {
          setOrders(res?.data?.getOrdersDetails);
          setTotalPages(Math.ceil(res.data?.orderDetailsCount / 50));
        } else {
          Toast("error", "Failed to fetch details");
        }
      }
    } catch (err) {
      CustomErrorResponse(err);
    }
  };

  const updateOrderStatus = async (orderId, status) => {
    try {
      await performRequest({
        method: "PUT",
        url: `/orders/update-status/${orderId}`,
        data: { status },
      });

      Toast("success", "Status updated");
      getOrders(); // refresh list
    } catch (err) {
      Toast.error("error", "Failed to update status");
    }
  };

  useEffect(() => {
    if (
      store?.AdditionalRole === "farmer partner" ||
      store?.Role === "superAdmin"
    ) {
      performRequest(
        "GET",
        `pmg/epg-analytics/get-farmer-partner-header-section-analytics/${
          farmerPartnerId ? farmerPartnerId : id
        }`
      )
        .then((res) => {
          setAnalyticsData(res?.data);
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }, [farmerPartnerId, id]);

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xxl">
          {/* HEADER */}
          <div className="page-header d-print-none mb-3">
            <div className="row align-items-center">
              <div className="col">
                <h2 className="page-title fw-bold">Farmer Partner Dashboard</h2>
              </div>
            </div>
          </div>
          <div className="row">
            {/* ✅ Stats Cards */}
            {[
              {
                title: "Total Orders",
                value: analyticsData?.totalOrders || "NA",
                icon: "ti ti-shopping-cart",
                color: "primary",
              },
              {
                title: "In Process",
                value: analyticsData?.processingOrders,
                icon: "ti ti-loader",
                color: "warning",
              },
              {
                title: "Pending",
                value: analyticsData?.pendingOrders,
                icon: "ti ti-loader",
                color: "danger",
              },
              {
                title: "Delivered",
                value: analyticsData?.deliveredOrders,
                icon: "ti ti-check",
                color: "success",
              },

              {
                title: "Total Revenue",
                value: analyticsData?.totalRevenue || "NA",
                icon: "ti ti-currency-rupee",
                color: "info",
              },
              {
                title: "Today's Revenue",
                value: analyticsData?.todaysRevenue || "NA",
                icon: "ti ti-chart-line",
                color: "secondary",
              },
            ].map((item, index) => (
              <div
                className="col-md-6 col-lg-3 mb-3  justify-content-between"
                key={index}
              >
                <div className={`card bg-${item.color}-lt`}>
                  <div className="card-body">
                    <div className="d-flex justify-between">
                      <div>
                        <div className="text-muted">{item.title}</div>
                        <div className="h3 m-0">{item.value}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}

            <div className="row">
              <div className="col-md-3 col-sm-12 pb-2">
                <div className="card p-2">
                  <div
                    id="faq-1"
                    className="accordion"
                    role="tablist"
                    aria-multiselectable="true"
                  >
                    <div>
                      <div className="accordion-header m-0" role="tab">
                        <button
                          className="accordion-button fs-3 d-md-none p-0"
                          data-bs-toggle="collapse"
                          data-bs-target="#faq-1-1"
                        >
                          <h3 className="m-1">Filter result</h3>
                        </button>
                      </div>

                      <div
                        id="faq-1-1"
                        className="accordion-collapse collapse d-md-none"
                        role="tabpanel"
                        data-bs-parent="#faq-1"
                      >
                        <div className="accordion-body pt-0">
                          <div className="row">
                            <div className="col-12">
                              <DynamicFilterSelect
                                label="Order status:"
                                onChange={(e) =>
                                  setFilters({
                                    ...filters,
                                    orderStatus: e.target.value,
                                  })
                                }
                                value={filters.orderStatus}
                              >
                                <option value="">Select</option>
                                <option value="pending">Pending</option>
                                <option value="processing">Processing</option>
                                <option value="packaged">Packaged</option>
                                <option value="outForDelivery">
                                  Out For Delivery
                                </option>
                                <option value="delivered">Delivered</option>
                              </DynamicFilterSelect>
                            </div>

                            <div className="col-12">
                              <DynamicFilterSelect
                                label="Sort by date:"
                                onChange={(e) =>
                                  setFilters({
                                    ...filters,
                                    sortByDate: e.target.value,
                                  })
                                }
                                value={filters.sortByDate}
                              >
                                <option value="">Select</option>
                                <option value="new orders">New orders</option>
                                <option value="old orders">Old orders</option>
                              </DynamicFilterSelect>
                            </div>
                            <div className="col-12">
                              <div className="row mt-2">
                                <div className="col-6">
                                  <button
                                    onClick={() => {
                                      setPage(1);
                                      setShowPage(1);
                                      setRefresh(!refresh);
                                    }}
                                    className="btn btn-success w-100"
                                  >
                                    Apply Filter
                                  </button>
                                </div>
                                <div className="col-6">
                                  <button
                                    onClick={() => {
                                      setFilters({
                                        sortByDate: "",
                                        orderStatus: "",
                                      });
                                      setPage(1);
                                      setRefresh(!refresh);
                                    }}
                                    className="btn btn-secondary w-100"
                                  >
                                    Reset Filter
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="accordion-body d-none d-md-block">
                        <div className="row">
                          <h3>Filter result</h3>
                          <div className="col-12">
                            <DynamicFilterSelect
                              label="Order status:"
                              onChange={(e) =>
                                setFilters({
                                  ...filters,
                                  orderStatus: e.target.value,
                                })
                              }
                              value={filters.orderStatus}
                            >
                              <option value="">Select</option>
                              <option value="pending">Pending</option>
                              <option value="processing">Processing</option>
                              <option value="packaged">Packaged</option>
                              <option value="outForDelivery">
                                Out For Delivery
                              </option>
                              <option value="delivered">Delivered</option>
                            </DynamicFilterSelect>
                          </div>

                          <div className="col-12">
                            <DynamicFilterSelect
                              label="Sort by date:"
                              onChange={(e) =>
                                setFilters({
                                  ...filters,
                                  sortByDate: e.target.value,
                                })
                              }
                              value={filters.sortByDate}
                            >
                              <option value="">Select</option>
                              <option value="new orders">New orders</option>
                              <option value="old orders">Old orders</option>
                            </DynamicFilterSelect>
                          </div>
                          <div className="col-12">
                            <div className="row mt-2">
                              <div className="col-6">
                                <button
                                  onClick={() => {
                                    setPage(1);
                                    setShowPage(1);
                                    setRefresh(!refresh);
                                  }}
                                  className="btn btn-success w-100"
                                >
                                  Apply Filter
                                </button>
                              </div>
                              <div className="col-6">
                                <button
                                  onClick={() => {
                                    setFilters({
                                      sortByDate: "",
                                      orderStatus: "",
                                    });
                                    setPage(1);
                                    setRefresh(!refresh);
                                  }}
                                  className="btn btn-secondary w-100"
                                >
                                  Reset Filter
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* ✅  Orders Table */}
              <div className="col-lg-9">
                <div className="card">
                  <div className="card-header">
                    <h3 className="card-title">Orders</h3>
                  </div>
                  <div className="table-responsive">
                    <table className="table card-table table-vcenter text-nowrap">
                      <thead>
                        <tr>
                          <th>Order ID</th>
                          <th>Amount</th>
                          <th>Payment</th>
                          <th>Status</th>
                          <th>Date</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {orders?.map((order, i) => {
                          const getStatusColor = (status) => {
                            switch (status) {
                              case "pending text-white":
                                return "warning text-white";
                              case "ongoing":
                                return "info text-white";
                              case "delivered":
                                return "success text-white";
                              case "cancelled":
                                return "danger text-white";
                              case "processing":
                                return "info text-white";
                              case "packaged":
                                return "info text-white";
                              case "outForDelivery":
                                return "info text-white";
                              case "delivered":
                                return "success text-white";
                              default:
                                return "secondary text-white";
                            }
                          };

                          return (
                            <tr key={i}>
                              {/* Order ID */}
                              <td>
                                <strong>{order.orderNumber}</strong>
                              </td>

                              {/* Amount */}
                              <td>₹{order.totalAmount}</td>

                              {/* Payment */}
                              <td>
                                <span
                                  className={`badge bg-${
                                    order.paymentStatus === "paid"
                                      ? "success text-white"
                                      : "danger text-white"
                                  }`}
                                >
                                  {order.paymentStatus}
                                </span>
                              </td>

                              {/* Order Status */}
                              <td>
                                <span
                                  className={`badge bg-${getStatusColor(
                                    order.orderStatus
                                  )}`}
                                >
                                  {order.orderStatus}
                                </span>
                              </td>

                              {/* Date */}
                              <td>
                                {new Date(order.createdAt).toLocaleDateString()}
                              </td>

                              {/* Actions */}
                              <td>
                                <div className="d-flex flex-wrap gap-1">
                                  {/* View Button */}
                                  <button
                                    className="btn btn-sm btn-primary"
                                    onClick={() =>
                                      navigate(
                                        `/farmer-epg-user-order_details/${order?.id}/${order?.farmerPartnerAssigned}`
                                      )
                                    }
                                  >
                                    View Order
                                  </button>

                                  {/* Workflow Buttons */}

                                  {/* {order.orderStatus === "pending" && (
                                  <button
                                    className="btn btn-sm btn-warning"
                                    onClick={() =>
                                      updateOrderStatus(order.id, "received")
                                    }
                                  >
                                    Mark Received
                                  </button>
                                )}

                                {order.orderStatus === "received" && (
                                  <button
                                    className="btn btn-sm btn-info"
                                    onClick={() =>
                                      updateOrderStatus(order.id, "packaged")
                                    }
                                  >
                                    Packaged
                                  </button>
                                )}

                                {order.orderStatus === "packaged" && (
                                  <button
                                    className="btn btn-sm btn-secondary"
                                    onClick={() =>
                                      updateOrderStatus(
                                        order.id,
                                        "out_for_delivery"
                                      )
                                    }
                                  >
                                    Out for Delivery
                                  </button>
                                )}

                                {order.orderStatus === "out_for_delivery" && (
                                  <button
                                    className="btn btn-sm btn-success"
                                    onClick={() =>
                                      updateOrderStatus(order.id, "delivered")
                                    }
                                  >
                                    Delivered
                                  </button>
                                )} */}
                                </div>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
                <Pagination
                  page={page}
                  totalPages={totalPages}
                  pageDatalength={data?.getOrdersDetails?.length}
                  setPage={setPage}
                  showPage={showPage}
                  setShowPage={setShowPage}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default FarmerEpgDashboard;
